import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import IconButton from '../../elements/IconButton'
import Dropdown from '../../elements/ReactSelectDropdown'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'

const Main = (props) => {

    const [agentList, setAgentList] = useState()

    useEffect(() => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({subagent: true}),
            redirect: 'follow'
        };

        props.tokenSafeAPIRequest('/user/search?limit=9999999&reverse_sort=false', requestOptions, '', (result) => {
            let dealers = []
            result.map((agent, index) => {
                dealers.push({value: agent.id, label: agent.first_name + " " + agent.last_name})
            })
            console.log(dealers)
            setAgentList(dealers)
        })
    },[])

    const [tempUnselectedAgents, setTempUnselectedAgents] = useState(props.unselectedAgents)

    function handleSelectingAgents(agentValue) {
        setTempUnselectedAgents(prev =>
            prev.includes(agentValue)
            ? prev.filter(v => v !== agentValue) // remove if exists
            : [...prev, agentValue]              // add if not
        );
    }

    const saveData = () => {
        props.setUnselectedAgent(tempUnselectedAgents);
        
    }

    return (
        <div style={{width: '360px', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Agent Filters</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column', borderTop: '1px solid ' + props.colors.border, marginTop: '10px'}}>
                {props.agentList?.map((agent, index) => {
                    console.log(agent)
                    return (agent.label === 'All Subagents' ? '':<div style={{display: 'flex', flexDirection: 'row', marginTop: index === 0 ? '20px':'10px'}}>
                            <span style={{marginRight: 'auto'}}>{agent.label}</span>
                            <div onClick={() => handleSelectingAgents(agent.value)} style={{cursor: 'pointer', width: '28px', height: '28px', border: !tempUnselectedAgents?.includes(agent.value) ? '2px solid ' + props.colors.primary:'2px solid ' + props.colors.border, borderRadius: '5px', backgroundColor: !tempUnselectedAgents?.includes(agent.value) ? props.colors.primary:'', marginTop: '-2px'}}></div>
                        </div>)
                })}
                <Button colors={props.colors} onClick={() => {saveData(); props.setIsOpen()}} active={true} Style={{height: '40px', marginTop: '20px'}}>Save Changes</Button>
                <Button colors={props.colors} onClick={() => setTempUnselectedAgents([])} active={true} Style={{height: '40px', marginTop: '20px'}}>Select All</Button>
                <Button colors={props.colors} onClick={() => setTempUnselectedAgents(props.agentList.filter(a => a.value !== "").map(a => a.value))} active={true} Style={{height: '40px', marginTop: '20px'}}>Unselect All</Button>
                {/*The complicated onCLick function for unselect all is to remove All Agents from prop value as that causes a 422*/}
            </div>
        </div>
    )
}

export default Main
